/**
 * Canonical internal-path helper.
 *
 * The router runs with `trailingSlash: "always"` and `src/server.ts` 301s any
 * bare path to its slash form. Data records (`salon.url`, `service.url`,
 * `navItem.to`, …) store paths WITHOUT a trailing slash because they also feed
 * schema/canonical builders. Normalise here, at the point of use, so every
 * internal `<Link>` targets the canonical form and never triggers a redirect.
 *
 * Static files (last segment contains a dot) and external/hash/mailto/tel
 * targets are returned untouched.
 */
export function internalPath(path: string): string {
  if (!path) return "/";
  if (/^(https?:|mailto:|tel:|#)/i.test(path)) return path;

  const [base, rest = ""] = splitSuffix(path);
  if (base === "" || base === "/") return `/${rest}`;

  const last = base.split("/").pop() ?? "";
  if (last.includes(".")) return path;

  return base.endsWith("/") ? path : `${base}/${rest}`;
}

/** Splits "/foo?a=1#b" into ["/foo", "?a=1#b"]. */
function splitSuffix(path: string): [string, string] {
  const i = path.search(/[?#]/);
  return i === -1 ? [path, ""] : [path.slice(0, i), path.slice(i)];
}
